<template>
  <div>
    <vs-input v-validate="'required|min:3'" data-vv-validate-on="blur" name="Username" icon-no-border
      icon="icon icon-user" icon-pack="feather" :label-placeholder="$t('UserName')" v-model="email" icon-after="true"
      class="w-full" />
    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

    <!-- <div class="center content-inputs">
    <vs-input
      type="password"
      v-model="value"
      label-placeholder="Password"

        icon-pack="feather"
      :visiblePassword="hasVisiblePassword"
      icon-after
       icon="icon icon-eye-off"
      @click-icon="hasVisiblePassword = !hasVisiblePassword">
    </vs-input>
  </div> -->


    <vs-input data-vv-validate-on="blur" v-validate="'required|min:6|max:40'" name="password" icon-no-border
      icon-pack="feather" :label-placeholder="$t('Password')" icon-after="true" :type="passwordType"
      icon="icon icon-eye-off" @icon-click="showPassword()" v-model="password" class="w-full mt-6" />

    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

    <div class="flex flex-wrap justify-between my-5">
      <vs-checkbox v-model="checkbox_remember_me" class="mb-3">{{ $t('RememperMe') }}</vs-checkbox>
      <router-link to="/pages/forgot-password">{{ $t('ForgotPassword') }}?</router-link>
    </div>
    <div class="flex flex-wrap justify-between mb-3">

      <vs-button type="border" @click="registerUser">{{ $t('Signup') }}</vs-button>
      <vs-button :disabled="!validateForm" @click="loginJWT">{{ $t('Login') }}</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      password: '',
      checkbox_remember_me: false,
      passwordType: "password",
      value: '',
      hasVisiblePassword: false
    }
  },
  computed: {

    validateForm() {
      return !this.errors.any() && this.email != '' && this.password != '';
    },
  },
  methods: {
    showPassword() {
      if (this.passwordType == 'text')
        this.passwordType = 'password'
      else
        this.passwordType = 'text'
    },
    checkLogin() {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {

        // Close animation if passed as payload
        // this.$vs.loading.close()

        // this.$vs.notify({
        //   title: 'Login Attempt',
        //   text: 'You are already logged in!',
        //   iconPack: 'feather',
        //   icon: 'icon-alert-circle',
        //   color: 'warning'
        // })
        this.$router.push({ name: 'home', });
        return false
      }
      return true
    },
    loginJWT() {
      //if (!this.checkLogin()) return
      // Loading
      this.$vs.loading();

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password
        }
      }

      this.$store.dispatch('auth/loginJWT', payload)
        .then(res => {
          this.$vs.loading.close()
          debugger;
          this.$acl.change(res.data.userData.userRole);
          if (localStorage.getItem('IncomeCode') != null && localStorage.getItem('IncomeCode') != undefined && res.data.userData.userRole == 'trainee') {
            // if(res.data.userData.userRole == "instructor")
            //     this.$router.push({name: 'ConfirmRegistration', params:{ID:localStorage.getItem('IncomeCode')} });
            //  else if(res.data.userData.userRole == "trainee")
            //     this.$router.push({name: 'CourseDetail', params:{ID:localStorage.getItem('IncomeCode')} });
            //     else
            debugger
            this.$router.push(this.$router.currentRoute.query.to)
          }

          else {
            debugger
            this.$router.push(this.$router.currentRoute.query.to || '/')
          }
          debugger
          // this.$router.push(this.$router.currentRoute.query.to || '/')

        })
        .catch((res) => {
          debugger
          this.$vs.loading.close()
          this.$vs.notify({
            fixed: true,
            title: 'Error',
            text: res.response.data == "this accoount not active" ? res.response.data : this.$t("errorinusernameorpassword"),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',

          })
        })
    },
    registerUser() {
      if (!this.checkLogin()) return
      this.$router.push('/registration/registerType').catch(() => { })
    }
  }
}

</script>

